import { useIntl } from 'react-intl'

import {
  Flex,
  Panel,
  SPACING_24,
  SpacingVertical,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import ApplyFilters from './ApplyFilters'
import ExcludeGroups from './ExcludeGroups'
import IncludeGroups from './IncludeGroups'

import ModalFilterDetails from '../../ModalFilterDetails/ModalFilterDetails'

export const Choose = () => {
  const intl = useIntl()

  return (
    <>
      <ModalFilterDetails />
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.Common.SegmentConditionTitle' })}
        </Title>
        <SpacingVertical variant={SPACING_24} />
        <Flex flexDirection='column' rowGap='8px'>
          <IncludeGroups />
          <ExcludeGroups />
          <ApplyFilters />
        </Flex>
      </Panel>
    </>
  )
}
